export default "__VITE_ASSET__7dcf3022__"